require("./apps.coffee");
require("./cloned_assessments.coffee");
require("./hire_step_days_to_fill.coffee");
require("./scorecard_links.coffee");
require("./send_offer_letter.coffee");
require("./upload_files.coffee");
